import { render, staticRenderFns } from "./CheckoutTip.vue?vue&type=template&id=e6d81c54&"
import script from "./CheckoutTip.vue?vue&type=script&lang=js&"
export * from "./CheckoutTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports